import { useContext } from 'react';
import { useLocalStore } from 'mobx-react';

import BookingContext from '../Contexts/BookingContext';
import BookingService from '../Services/BookingService';
import useAuth from '../../ISO/Hooks/useAuth';
import useApi from '../../ISO/Hooks/useApi';

export default function UseBookingService(): BookingService {
  const context = useContext(BookingContext);
  const bookingService = useLocalStore<BookingService>(() => context);
  const api = useApi();
  const auth = useAuth();

  bookingService.setApi(api);
  bookingService.setAuth(auth.authService);

  return bookingService;
}
